export const isCalendarEventLoading = ref(false)
